import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import TopBar from './TopBar';
import './Layout.css';

const AdminLayout: React.FC = () => {
  return (
    <div className="layout">
      <AdminSidebar />
      <div className="layout-main">
        <TopBar />
        <div className="layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
